import styled, { css } from "styled-components"
import { GoldButton } from "../../SearchComponent/style"

export const GoldenButton = styled(GoldButton)`
  @media (max-width: 1149px) {
    display: none;
  }

  @media (max-width: 799px) {
    display: unset;
  }
`

export const TabletButtonBox = styled.div`
  width: 100%;
  display: none;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;

  & > div {
    width: 83.3%;

    a {
      text-decoration: none;
    }

    button {
      width: 100%;
    }

    @media (max-width: 1149px) {
      width: 82.5%;
    }

    @media (max-width: 799px) {
      width: 88.88%;
    }
  }

  @media (max-width: 1149px) {
    display: flex;
  }

  @media (max-width: 799px) {
    display: none;
  }
`

export const Main = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(17, 17, 17, 0.75);
  padding: 30px 0;
  margin-bottom: 92px;

  @media (max-width: 1149px) {
    margin-bottom: 42px;
  }

  @media (max-width: 799px) {
    margin-bottom: 74px;
  }
`
export const Wrapper = styled.div`
  width: 83.3%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1149px) {
    width: 82.5%;
  }

  @media (max-width: 799px) {
    width: unset;
    flex-direction: column;
    gap: 44px;
  }
`

export const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  @media (max-width: 799px) {
    align-self: flex-start;
  }

  h4 {
    font-size: 2.3rem;
    font-weight: 700;
    line-height: 3.5rem;
    letter-spacing: 0;
    background: linear-gradient(
      90deg,
      #bb913c 0%,
      #eae69c 32.29%,
      #ce9638 82.29%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  p {
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.1rem;
    letter-spacing: 0;
    color: #fdfdfd;
  }
`

export const RateBox = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 799px) {
    align-self: flex-start;
  }

  & > p {
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.1rem;
    letter-spacing: 0;
    color: #fdfdfd;
  }
`

export const StarsBox = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  span {
    display: flex;
    align-items: flex-end;
  }

  p {
    font-size: 2.3rem;
    font-weight: 700;
    line-height: 3.5rem;
    letter-spacing: 0;
    color: #ce9638;
    margin-top: 5px;

    &:last-of-type {
      font-size: 1.4rem;
      font-weight: 500;
      line-height: 2.1rem;
      margin-bottom: 5px;
    }
  }
`

export const Star = styled.svg`
  height: 22px;
  width: 25px;

  ${props =>
    props.ratingValue - 0.2 <= props.rating
      ? css`
          &:nth-of-type(1) {
            fill: #ddcd80;
          }

          &:nth-of-type(2) {
            fill: #d4bc6d;
          }

          &:nth-of-type(3) {
            fill: #cfb262;
          }

          &:nth-of-type(4) {
            fill: #c9a754;
          }

          &:nth-of-type(5) {
            fill: #c09742;
          }
        `
      : css`
          opacity: 0;
        `}
`

export const HalfStar = styled.svg`
  height: 22px;
  width: 25px;

  &:nth-of-type(1) {
    fill: #ddcd80;
  }

  &:nth-of-type(2) {
    fill: #d4bc6d;
  }

  &:nth-of-type(3) {
    fill: #cfb262;
  }

  &:nth-of-type(4) {
    fill: #c9a754;
  }

  &:nth-of-type(5) {
    fill: #c09742;
  }
`
